<template>
  <v-container color="primary" class="pa-4" style="max-width: 1000px;">
    <!-- Diálogo con v-calendar -->
    <v-dialog v-model="dialogVentana" max-width="1800px">
      <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-title>
                Calendario Diario
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-layout wrap>
            <v-flex sm4 xs12 class="text-sm-left text-xs-center">
                <v-btn :loading="loadingShippingWindows" @click="goPrev()" color="primary">
                    <v-icon
                    dark
                    left
                    >
                    keyboard_arrow_left
                    </v-icon>
                    Atras
                </v-btn>
            </v-flex>
            <v-flex sm4 xs12 class="text-xs-center">
              <v-menu
                  ref="menuVentana2"
                  v-model="menuVentana2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                        v-model="form.fechaVentana"
                        label="Fecha"
                        prepend-icon="today"
                        readonly
                        outlined
                        v-bind="attrs"
                        v-on="on"
                    />
                  </template>
                  <v-date-picker
                    ref="picker"
                    v-model="form.fechaVentana"
                    :locale="$t('region')"
                    @change="saveDate"
                    @input="menuVentana2 = false"
                  />
              </v-menu>
            </v-flex>
            <v-flex sm4 xs12 class="text-sm-right text-xs-center">
                <v-btn :loading="loadingShippingWindows" @click="goNext" color="primary">
                    Siguiente
                    <v-icon
                    right
                    dark
                    >
                    keyboard_arrow_right
                    </v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs1.5 v-for="(item, index) in calendars" :key="index" class="text-xs-center">
                {{ item.name }}<br><br>
                <v-calendar
                  ref="calendarwe"
                  v-model="currentDate"
                  hide-header
                  :value="today"
                  :weekdays="[1, 2, 3, 4, 5, 6, 0]"
                  type="day"
                  :locale="$t('region')"
                  :interval-minutes="30"
                  :interval-count="numberSlots"
                  :first-interval="0"
                  :events="item.events"
                  :interval-format="intervalFormat"
                  @click:time="agregarNewEventoToCalendar($event, index, item.id)"
                >                    
                  <!-- the events at the top (all-day) -->
                  <!-- <template v-slot:dayHeader="{ date }">
                      <template v-for="event in eventsMap[date]"> -->
                      <!-- all day events don't have time -->
                      <!-- <div
                          v-if="!event.time"
                          :key="event.title"
                          class="my-event"
                          @click="open(event)"
                          v-html="event.title"
                      ></div>
                      </template>
                  </template> -->
                  <template v-slot:interval="{ hour, minute }">
                    <div
                      class="text-xs-center"
                    >
                      {{ hour }}:{{ minute }}
                    </div>
                  </template>
                  <!-- the events at the bottom (timed) -->
                    <template v-slot:dayBody="{ date, timeToY, minutesToPixels }">
                      <template v-for="(event, eventIndex) in eventsMap[index][date]">
                          <!-- timed events -->
                          <div
                              v-if="event.color === 'blue'"
                          :key="`blue-${date}-${event.time}-${event.id || 'noid'}-${eventIndex}`"
                              :style="{ top: timeToY(event.time) + 'px', height: minutesToPixels(event.duration) + 'px' }"
                              class="my-event with-time"
                              @click="open(event)"
                              v-html="event.title"
                          ></div>
                          <!-- timed events -->
                          <div
                              v-else-if="event.id === item.id"
                          :key="`green-${date}-${event.time}-${event.id || 'noid'}-${eventIndex}`"
                              :style="{ top: timeToY(event.time) + 'px', height: minutesToPixels(event.duration) + 'px' }"
                              class="my-event2 with-time2"
                              @click="open(event)"
                              v-html="event.title"
                          ></div>
                          <!-- timed events -->
                          <div
                              v-else-if="event.color === 'red'"
                          :key="`red-${date}-${event.time}-${event.id || 'noid'}-${eventIndex}`"
                              :style="{ top: timeToY(event.time) + 'px', height: minutesToPixels(event.duration) + 'px' }"
                              class="my-event3 with-time3"
                              @click="open(event)"
                              v-html="event.title"
                          ></div>
                      </template>
                  </template>
                </v-calendar>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogVentana = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogCalendario" max-width="1200px">
      <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-title>
                Calendario por Dia 
            </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs2 v-for="i in 4">
            Hola
          </v-flex>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialogCalendario = false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Diálogo con formulario -->
    <v-dialog v-model="dialogClientes" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Capturar Datos del Nuevo Cliente</span>
        </v-card-title>

        <v-card-text>
          <v-form ref="form" v-model="valid" lazy-validation>

            <!-- N° de Cliente -->
            <v-text-field
              v-model="client.code"
              label="N° de Cliente"
              type="number"
              :rules="[v => !!v || 'El número es requerido']"
              color="primary"
            ></v-text-field>

            <!-- Nombre del Cliente -->
            <v-text-field
              v-model="client.name"
              label="Nombre del Cliente"
              :rules="[v => !!v || 'El nombre es requerido']"
              color="primary"
            ></v-text-field>

            <!-- Domicilio -->
            <v-text-field
              v-model="client.address"
              label="Domicilio"
              :rules="[v => !!v || 'El domicilio es requerido']"
              color="primary"
            ></v-text-field>

            <!-- Tiempo de carga -->
            <v-text-field
              v-model="client.loading_time_minutes"
              label="Tiempo de carga (min)"
              type="number"
              min="1"
              :rules="[v => !!v || 'El tiempo es requerido']"
              color="primary"
            ></v-text-field>

          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="dialogClientes = false">
            Cancelar
          </v-btn>
          <v-btn color="primary" flat @click="guardarCliente">
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-title>
                {{$t('Invitacion')}}
            </v-toolbar-title>
        </v-toolbar>
      <v-card-text>
        <v-form v-model="valid">
            <v-layout row wrap>
                <!-- <v-flex xs3>
                    <v-checkbox
                    v-model="form.opciones"
                    prepend-icon="domain"
                    label="Empresarial"
                    value="Empresarial"
                    hide-details
                    dense
                    ></v-checkbox>
                </v-flex>
                <v-flex xs3>
                    <v-checkbox
                    v-model="form.opciones"
                    prepend-icon="anchor"
                    label="Embarque"
                    value="Embarque"
                    hide-details
                    dense
                    ></v-checkbox>
                </v-flex> -->
                <!-- <v-flex xs3>
                    <v-checkbox
                    v-model="form.opciones"
                    prepend-icon="update"
                    label="Recurrente"
                    value="Recurrente"
                    hide-details
                    dense
                    ></v-checkbox>
                </v-flex>
                <v-flex xs3>
                    <v-checkbox
                    v-model="form.opciones"
                    prepend-icon="local_activity"
                    label="VIP"
                    value="VIP"
                    hide-details
                    dense
                    ></v-checkbox>
                </v-flex> -->
            </v-layout>
            <br><br>
          <!-- FILA 1: EMPRESA Y ADMINISTRADOR -->
          <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
                v-model="id_empresa_empresarial"
                :items="items"
                prepend-icon="business"
                :loading="isLoading_empresas"
                :search-input.sync="search"
                item-text="name"
                item-value="id"
                box
                :placeholder="$t('placeholder_empresas')"
                :label="$t('Empresa')"
                :error-messages="errores.empresa_id"
                :no-data-text="$t('no_resultados')"
                @input="get_managerByCompany(id_empresa_empresarial)"
                clearable
              >
                <template v-slot:selection="data">
                    <v-chip
                      :selected="data.selected"
                      class="chip--select-multi"
                    >
                      {{ data.item.name }}
                    </v-chip>
                </template>
                <template v-slot:item="data">
                  {{ data.item.name }}
                </template>
              </v-autocomplete>
              <!-- <v-autocomplete
                v-model="form.empresa"
                :items="empresas"
                item-text="nombre"
                item-value="id"
                label="Empresa"
                chips
                outlined
                prepend-icon="domain"
                placeholder="Buscar por Empresa"
                clearable
              /> -->
            </v-flex>
            <v-flex xs6>
              <!-- <v-autocomplete
                v-model="form.administrador"
                :items="administradores"
                item-text="email"
                item-value="id"
                label="Administrador"
                chips
                outlined
                prepend-icon="mail"
                placeholder="E-Mail del Administrador"
                clearable
              /> -->
              <v-autocomplete
                v-model="admin"
                prepend-icon="email"
                name="admin"
                box
                return-object
                item-text="first_name"
                item-value="email"
                :label="$t('email_admin')"
                :filter="customFilterAdministradores"
                :error-messages="errores.referred_email"
                :items="administradores"
                :no-data-text="$t('no_resultados')"
                clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    class="chip--select-multi"
                  >
                    {{data.item.email}}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  {{data.item.first_name}} {{ data.item.last_name}} - {{data.item.email}}
                </template>
              </v-autocomplete>
            </v-flex>
            <v-alert
              :value="bandSinAdministrador === true"
              type="error"
              outline
              transition="scale-transition"
            >
              {{$t('msg_no_manager_found')}}
            </v-alert>
          </v-layout>

          <!-- FILA 2: AREA DE CARGA Y FECHA -->
          <!-- <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
                v-model="form.client"
                :items="clients"
                item-text="name"
                item-value="id"
                :error-messages="errores.parking_section_id"
                label="Cliente"
                chips
                outlined
                prepend-icon="corporate_fare"
                placeholder="Buscar por Nombre"
                @input="rellenaCamposDireccionDuracionCarga(form.client)"
                clearable
              />
            </v-flex>
            <v-flex xs6 class="text-xs-center">
              <v-btn
                color="primary"
                :disabled="this.form.address === ''"
                :loading="loadingShippingWindows"
                @click="fillRandomCalendars()"
              >
                {{ $t('check_parking_availability') }}<v-icon>local_parking</v-icon>
              </v-btn>
              <v-menu
                ref="menuVentana"
                v-model="menuVentana"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaVentana"
                    :label="$t('fecha_inv')"
                    prepend-icon="today"
                    readonly
                    disabled
                    outlined
                    v-bind="attrs"
                  />
                </template>
                <v-date-picker
                  v-model="form.fechaVentana"
                  @input="menuVentana = false"
                />
              </v-menu>
            </v-flex>
          </v-layout> -->

          <!-- FILA 2.1: Días de la Semana Y Fecha Final -->
          <v-layout row wrap v-show="form.opciones.includes('Recurrente')">
            <v-flex xs6>              
              <div v-if="form.opciones.includes('Recurrente')" class="subheading mb-2">Selecciona los días</div>
              <v-layout row wrap v-if="form.opciones.includes('Recurrente')">
                <v-flex v-for="dia in diasSemana" :key="dia" xs6>
                  <v-checkbox
                    v-model="form.dias"
                    :label="dia"
                    :value="dia"
                    hide-details
                    dense
                  ></v-checkbox>
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex xs6>
              <v-menu
              v-if="form.opciones.includes('Recurrente')"
                ref="menuVentanaRecurrente"
                v-model="menuVentanaRecurrente"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.fechaVentanaRecurrente"
                    label="Fecha Final"
                    prepend-icon="today"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  />
                </template>
                <v-date-picker v-model="form.fechaVentanaRecurrente" @input="menuVentanaRecurrente = false" />
              </v-menu>
            </v-flex>
          </v-layout>

          <!-- FILA 3: Planta Destino Y Hora -->

          <v-layout row wrap>
            <v-flex xs12>
              <v-autocomplete
                v-model="form.areas"
                :items="parkingSpaces"
                item-text="number"
                item-value="id"
                :label="$t('parking_space')"
                :error-messages="errores.parking_space_ids"
                chips
                outlined
                prepend-icon="space_dashboard"
                placeholder="Selecciona uno o mas cajones"
                multiple
                clearable
              >
                <template v-slot:selection="data">
                  <v-chip
                    :selected="data.selected"
                    class="chip--select-multi"
                  >
                    {{data.item.number}} - {{data.item.space_type_name ? data.item.space_type_name : 'N/A'}}
                  </v-chip>
                </template>
                <template v-slot:item="data">
                  {{data.item.number}} - {{data.item.space_type_name ? data.item.space_type_name : 'N/A'}}
                </template>
              </v-autocomplete>
            </v-flex>
            <!-- <v-flex xs6>
              <v-autocomplete
                v-model="form.vehicle_type"
                :items="vehicleTypes"
                item-text="name"
                item-value="id"
                :label="$t('vehicle_type')"
                :error-messages="errores.vehicle_type_id"
                chips
                outlined
                prepend-icon="commute"
                placeholder="Selecciona un tipo de vehiculo"
                clearable
              />
            </v-flex> -->
          </v-layout>

          <!-- FILA 3: Planta Destino Y Hora -->
          <!-- <v-layout row wrap>
            <v-flex xs6>
              <v-autocomplete
                v-model="form.areas"
                :items="parkingSpaces"
                disabled
                item-text="name"
                item-value="id"
                :label="$t('landing_area')"
                chips
                outlined
                prepend-icon="grid_view"
                placeholder="Buscar por ID"
                readonly
              />
            </v-flex>
            <v-flex xs1>
                <v-btn
                    icon
                    color="primary"
                    class="mt-4"
                    @click="abrirDialogClientes"
                >
                    <v-icon>add</v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs1>
                <v-btn
                    icon
                    color="primary"
                    class="mt-4"
                    @click="llenarDialogClientes"
                >
                    <v-icon>edit</v-icon>
                </v-btn>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                outlined
                disabled
                prepend-icon="schedule"
                v-model="form.hora"
                :error-messages="errores.invitation_time"
                :label="$t('hora_inv')"
                type="time"
              />
            </v-flex>
          </v-layout> -->

          <!-- FILA 4: Domicilio/Duracion de la Carga Y Tipo de Transporte -->
          <v-layout row wrap>
            <v-flex xs6>
              <v-textarea
                v-model="form.subject"
                :label="$t('Asunto')"
                :error-messages="errores.subject"
                :placeholder="$t('placeholder_asunto')"
              />
            </v-flex>
            <v-flex xs6>
                <v-row dense>
                    <v-col>
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.fecha"
                                :label="$t('Fecha_ini')"
                                prepend-icon="today"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                            />
                            </template>
                            <v-date-picker
                              :locale="$t('region')"
                              :min="currentDate"
                              @change="saveDate2"
                              v-model="form.fecha"
                              @input="menu = false"
                            />
                        </v-menu>
                    </v-col>
                    <v-col>
                        <v-menu
                            ref="menuExpiracion"
                            v-model="menuExpiracion"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                        >
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                                v-model="form.fechaExpiracion"
                                :label="$t('fecha_expiracion')"
                                prepend-icon="today"
                                readonly
                                outlined
                                v-bind="attrs"
                                v-on="on"
                            />
                            </template>
                            <v-date-picker
                              :locale="$t('region')"
                              :min="currentDate"
                              @change="saveDateExpiracion"
                              v-model="form.fechaExpiracion"
                              @input="menuExpiracion = false"
                            />
                        </v-menu>
                    </v-col>
                </v-row>
            </v-flex>
          </v-layout>

          <v-layout row wrap>
            <v-flex xs12>
              <v-radio-group
                v-model="form.scheduleMode"
                row
                class="mt-0"
                @change="clearTimeErrors"
              >
                <v-radio label="Reserva todo el dia" value="all_day"></v-radio>
                <v-radio label="Reserva por horas" value="by_hours"></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex xs12 sm6 v-if="form.scheduleMode === 'by_hours'">
              <v-menu
                ref="menuStartTime"
                v-model="menuStartTime"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="form.start_time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    outlined
                    v-model="form.start_time"
                    label="Hora inicio"
                    prepend-icon="schedule"
                    :error-messages="errores.start_time"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menuStartTime"
                  v-model="form.start_time"
                  format="24hr"
                  full-width
                  @click:minute="$refs.menuStartTime.save(form.start_time); clearTimeErrors()"
                ></v-time-picker>
              </v-menu>
            </v-flex>
            <v-flex xs12 sm6 v-if="form.scheduleMode === 'by_hours'">
              <v-menu
                ref="menuEndTime"
                v-model="menuEndTime"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="form.end_time"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    outlined
                    v-model="form.end_time"
                    label="Hora fin"
                    prepend-icon="schedule"
                    :error-messages="errores.end_time"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-time-picker
                  v-if="menuEndTime"
                  v-model="form.end_time"
                  format="24hr"
                  full-width
                  @click:minute="$refs.menuEndTime.save(form.end_time); clearTimeErrors()"
                ></v-time-picker>
              </v-menu>
            </v-flex>
          </v-layout>

          <!-- FILA 5: DÍAS Y NOTAS -->
          <v-layout row wrap>
            <v-flex xs6>
              <v-textarea
                v-model="form.notes"
                :label="$t('Notas')"
                :error-messages="errores.notes"
                :placeholder="$t('placeholder_notas')"
              />
            </v-flex>
            <v-flex xs12 sm6 v-show="documentationsByCompany.length > 0">
                <div class="subheading mb-2">Documentos adicionales</div>
                <div class="text mb-2">* Documentos requeridos para validación</div>
                <v-layout row wrap>
                    <v-flex v-for="(doc, docIndex) in documentationsByCompany" :key="doc.idDocumentation || doc.id || docIndex" xs6>
                    <v-checkbox
                        v-model="documentos"
                        :label="doc.name"
                        :value="doc.idDocumentation"
                        hide-details
                        dense
                    ></v-checkbox>
                    </v-flex>
                </v-layout>
            </v-flex>
          </v-layout>

          <!-- BOTONES -->
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <!-- <v-btn color="primary" @click="generarPDF" :disabled="!valid" class="mr-2">
                Generar PDF
              </v-btn> -->
              <v-btn color="primary" @click="enviarInvitacion" :loading="loadingInvitacion">
                Enviar
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import JSPDF from 'jspdf'
import '@/plugins/axios'
import store from '@/store'
import {mapGetters, mapState} from 'vuex'

export default {
  data: () => ({
    valid: true,
    menu: false,
    menuExpiracion: false,
    menuStartTime: false,
    menuEndTime: false,
    today: new Date().toLocaleDateString(), // '2025-03-31',
    menuVentana: false,
    menuVentana2: false,
    menuVentanaRecurrente: false,
    dialogClientes: false,
    dialogVentana: false,
    dialogCalendario: false,
    eventos: [
        {        
            title: 'Seleccionado',
            date: '2025-06-23',
            time: '01:30', // Evento de 30 min
            duration: 30,
            color: 'green'
        },
        {        
            title: 'Ocupado',
            date: '2025-06-23',
            time: '02:00', // Evento de 30 min
            duration: 30,
            color: 'blue'
        }
    ],
    selected: new Date().toLocaleDateString(), // '2025-03-31',
    documentos: [],
    diasSemana: [
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
      'Domingo'
    ],
    form: {
      opciones: [],
      fecha: '',
      fechaExpiracion: '',
      scheduleMode: 'all_day',
      start_time: '',
      end_time: '',
      fechaVentana: '',
      fechaVentanaRecurrente: '',
      hora: '',
      dias: [],
      documentos: [],
      personas: [],
      areas: null,
      client: '',
      address: '',
      loading_time_minutes: '',
      typeTransport: '',
      subject: '',
      notes: '',
      empresa: '',
      administrador: ''
    },
    parkingSpaces: [],
    clients: [],
    client: {
        code: '',
        name: '',
        address: '',
        loading_time_minutes: ''
    },
    typesOfTransports: [],
    empresas: [
      { id: 1, nombre: 'Transportes y Logística S.A.' },
      { id: 2, nombre: 'Logística Integral S.A. de C.V.' },
      { id: 3, nombre: 'Transporte Express S.A.' },
      { id: 4, nombre: 'Servicios de Carga Rápida S.A.' },
      { id: 5, nombre: 'Logística Avanzada S.A. de C.V.' }
    ],
    administradores: [],
    timeInterval: 10,
    numberSlots: 48,
    disabledCalendar: true,
    disabledCalendar2: true,
    disabledCalendar3: true,
    disabledCalendar4: true,
    disabledCalendar5: true,
    disabledCalendar6: true,
    calendars: [],
    id_empresa: '',
    currentDate: null,
    loadingShippingWindows: false,
    id_empresa_empresarial: '',
    admin: {},
    isLoading_empresas: false,
    bandSinAdministrador: false,
    entries2: [],
    search: null,
    errores: {},
    loadingInvitacion: false,
    bandDeleteEvent: false,
    documentationsByCompany: [],
    vehicleTypes: [],
  }),
  created: function(){
    this.getDocumentationByCompany()
    this.get_extra_data()
    const now = new Date();
    this.currentDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`; // Local YYYY-MM-DD
    this.form.fecha = this.currentDate
    this.form.fechaExpiracion = this.currentDate
  },
  computed: {
    ...mapGetters(['getProfile']),
    ...mapState(['language']),
    fields () {
      if (!this.id_empresa_empresarial) return []
      return Object.keys(this.id_empresa_empresarial).map(key => {
        return {
          key,
          value: this.id_empresa_empresarial[key] || 'n/a'
        }
      })
      console.log('Se activo....')
      },
      items () {
        return this.entries2.map(entry => {
          const name = entry.name.length > this.descriptionLimit
              ? entry.name.slice(0, this.descriptionLimit) + '...'
              : entry.name

          return Object.assign({}, entry, { name })
        })          
      },
      // convert the list of events into a map of lists keyed by date
      eventsMap () {
        let algo = []
        for (let i = 0; i < this.calendars.length; i++) {  
          const map = {}
          this.calendars[i].events.forEach(e => (map[e.date] = map[e.date] || []).push(e))
          console.log('Mapa de eventos:', map)
          algo.push(map)
        }
        return algo
      }
  },
  watch: {
      isUpdating (val) {
        if (val) {
            setTimeout(() => (this.isUpdating = false), 3000)
        }
      },
      search (val) {
        console.log(val)
        if (val !== null && val !== undefined) {
          if (val.length > 2) {
            this.isLoading_empresas = true
            const config = {
              method: 'get',
              url: 'https://empresa-service.intrare.app/empresas/filter?search=' + val,
              headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
              }
            };
            axios(config)
              .then(response => {
                console.log(response.data)
                if (this.entries2.length > 0) {
                  for (var i = 0; i < response.data.length; i++) {
                    this.entries2.push(response.data[i])
                  }
                } else
                  this.entries2 = response.data
              })
              .catch(error => {
                console.log(error)
              })
              .finally(() => (this.isLoading_empresas = false))
          }
        }
      }
  },
  methods: {
    clearTimeErrors () {
      if (this.errores.start_time) {
        this.$delete(this.errores, 'start_time')
      }
      if (this.errores.end_time) {
        this.$delete(this.errores, 'end_time')
      }
    },
    toMinutes (timeValue) {
      if (!timeValue) return null
      const parts = String(timeValue).split(':')
      if (parts.length < 2) return null
      const hour = parseInt(parts[0], 10)
      const minute = parseInt(parts[1], 10)
      if (Number.isNaN(hour) || Number.isNaN(minute)) return null
      return (hour * 60) + minute
    },
    validateScheduleMode () {
      this.clearTimeErrors()
      if (this.form.scheduleMode !== 'by_hours') {
        return true
      }

      if (!this.form.start_time) {
        this.$set(this.errores, 'start_time', 'Selecciona la hora de inicio.')
      }
      if (!this.form.end_time) {
        this.$set(this.errores, 'end_time', 'Selecciona la hora de fin.')
      }

      if (this.errores.start_time || this.errores.end_time) {
        return false
      }

      const startMinutes = this.toMinutes(this.form.start_time)
      const endMinutes = this.toMinutes(this.form.end_time)
      if (startMinutes === null || endMinutes === null || endMinutes <= startMinutes) {
        this.$set(this.errores, 'end_time', 'La hora fin debe ser mayor a la hora inicio.')
        return false
      }

      return true
    },
    getParkingSpacesInitial (){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/Parking/spaces/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        params: {
          id_section__idEmpresa: this.id_empresa,
          is_active: true
        }
      };
      axios(config)
        .then(response => {
          this.parkingSpaces = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getDocumentationByCompany: function(){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/documentation/ListCreate/',
        headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
        }
      };
      axios(config)
        .then(response => {
            this.documentationsByCompany = response.data
        })
        .catch(error => {
            console.log(error)
        })
    },
    customFilterAdministradores (item, queryText) {
      const textOne = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()
      return textOne.indexOf(searchText) > -1
    },
    get_name_company(){
      // console.log('VALOR DE CAMPO = ', this.id_empresa_empresarial)
      for(var i = 0 ; i < this.entries2.length ; i++){
        if(this.entries2[i].id === this.id_empresa_empresarial) {
          // console.log('NAME COMPANY = ', this.entries2[i].name)
          return this.entries2[i].name
        }
      }
    },
    get_managerByCompany: function(id_company){
        console.log(id_company)
        if (id_company !== null && id_company !== undefined) {
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/empresas/administradoresByCompany/' + id_company,
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    if (response.data.length === 0) {
                        this.admin = {}
                        this.bandSinAdministrador = true
                    } else {
                        this.bandSinAdministrador = false
                    }
                    this.administradores = response.data
                })
                .catch(error => {
                    console.log(error)
                })
        } else {
            this.admin = {}
            this.administradores = []
            this.bandSinAdministrador = false
        }
    },
    fillRandomCalendars () {
      this.getParkingSpaces(this.form.client)
      this.bandDeleteEvent = true
      this.loadingShippingWindows = true
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/shipping-windows/by_date_range/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
            start_date: this.currentDate,
            end_date: this.currentDate,
            empresa: this.id_empresa
          }
      };
      axios(config)
          .then(response => {
              if (this.calendars.length > 0) {
              for (let i = 0; i < this.calendars.length; i ++) {
                for (let j = 0; j < response.data.length; j++) {
                  if(response.data[j].loading_area === this.calendars[i].id) {
                    this.calendars[i].events.push(
                      {
                        title: response.data[j].status,
                        date: response.data[j].window_date,
                        time: response.data[j].window_time,
                        duration: response.data[j].loading_time_minutes,
                        color: 'blue',
                        id: response.data[j].id,
                        new: false
                      }
                    )
                  }
                }
              }
            }
            this.loadingShippingWindows = false
            this.dialogVentana = true
          })
          .catch(error => {
              console.log(error)
              this.loadingShippingWindows = false
          })
    },
    fillCalendars (start_date, end_date) {
      this.loadingShippingWindows = true
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/shipments/shipping-windows/by_date_range/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
            start_date: start_date,
            end_date: end_date,
            empresa: this.id_empresa
          }
      };
      axios(config)
          .then(response => {
              if (this.calendars.length > 0) {
              for (let i= 0; i< this.calendars.length ;i ++)
                this.calendars[i].events = []  
              for (let i = 0; i < this.calendars.length; i ++) {
                for (let j = 0; j < response.data.length; j++) {
                  if(response.data[j].loading_area === this.calendars[i].id) {
                    this.calendars[i].events.push(
                      {
                        title: response.data[j].status,
                        date: response.data[j].window_date,
                        time: response.data[j].window_time,
                        duration: response.data[j].loading_time_minutes,
                        color: 'blue',
                        id: response.data[j].id,
                        new: false
                      }
                    )
                  }
                }
              }
            }
            this.loadingShippingWindows = false
          })
          .catch(error => {
              console.log(error)
              this.loadingShippingWindows = false
          })
    },
    saveDate2 (date) {
      this.form.fecha = date
    },
    saveDateExpiracion (date) {
      this.form.fechaExpiracion = date
    },
    saveDate (date) {
      this.currentDate = date
      this.fillCalendars(this.currentDate, this.currentDate)
      this.form.fechaVentana = date
    },
    goNext() {
      // Convertir la fecha actual en Date
      const d = new Date(this.currentDate)
      // Avanzar 1 día
      d.setDate(d.getDate() + 1)
      // Volver a colocarla en formato YYYY-MM-DD
      this.currentDate = d.toISOString().substr(0,10)
      this.form.fechaVentana = this.currentDate
      this.form.hora = ''
      this.fillCalendars(this.currentDate, this.currentDate)
      console.log('Fecha == ', this.currentDate)
    },
    goPrev() {
      // Convertir la fecha actual en Date
      const d = new Date(this.currentDate)
      // Avanzar 1 día
      d.setDate(d.getDate() - 1)
      // Volver a colocarla en formato YYYY-MM-DD
      this.currentDate = d.toISOString().substr(0,10)
      this.form.fechaVentana = this.currentDate
      this.form.hora = ''
      this.fillCalendars(this.currentDate, this.currentDate)
      console.log('Fecha == ', this.currentDate)
    },
    get_extra_data (){
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/auth/me',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          }
      };
      axios(config)
          .then(response => {
            this.id_empresa = response.data.id_company
            this.getParkingSpacesInitial()
            this.getClients()
            this.getVehicleTypes()
          })
          .catch(error => {
              console.log(error)
          })
    },
    createVCalendars (datos) {
      this.calendars = []
      for (let i = 0; i < datos.length; i++){
        this.calendars.push(
          {
            id: datos[i].id,
            name: datos[i].number,
            focus: "",
            events: []
          }
        )
      }
    },
    getParkingSpaces (idSection){
      const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/Parking/spaces/',
          headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
          },
          params: {
              id_section: idSection
          }
      };
      axios(config)
          .then(response => {
              this.parkingSpaces = response.data
              this.createVCalendars(response.data)
          })
          .catch(error => {
              console.log(error)
          })
    },
    getClients () {
        const config = {
            method: 'get',
            url: 'https://empresa-service.intrare.app/Parking/sections/',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Token ' + store.getters.getToken
            },
            params: {
                idEmpresa: this.id_empresa,
                is_active: true
            }
        };
        axios(config)
            .then(response => {
                this.clients = response.data
            })
            .catch(error => {
                console.log(error)
            })
    },
    getVehicleTypes () {
        const config = {
          method: 'get',
          url: 'https://empresa-service.intrare.app/Parking/vehicle-types/active/',
          params: {
            idEmpresa: this.id_empresa
          },
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        };
        axios(config)
          .then(response => {
            this.vehicleTypes = response.data
          })
          .catch(error => {
            console.log(error)
          })
    },
    getTypesOfTransports (){
      const config = {
        method: 'get',
        url: 'https://empresa-service.intrare.app/shipments/carrier-types/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        },
        params: {
          IdEmpresa: this.id_empresa,
          is_active: true
        }
      };
      axios(config)
      .then(response => {
          this.typesOfTransports = response.data
      })
      .catch(error => {
          console.log(error)
      })
    },
    abrirDialogClientes() {
      this.dialogClientes = true
      this.$refs.form.resetValidation()
      this.limpiarFormulario()
    },
    llenarDialogClientes() {
      this.dialogClientes = true
      this.client = {
        code: this.clients[0].code,
        name: this.clients[0].name,
        address: this.clients[0].address,
        loading_time_minutes: this.clients[0].loading_time_minutes
      }
    },
    guardarCliente() {
      if (this.$refs.form.validate()) {
        console.log('Datos del cliente:', this.client)
        alert('Cliente guardado correctamente')
        this.dialogClientes = false
        this.limpiarFormulario()
      }
    },
    limpiarFormulario() {
      this.client = {
        code: '',
        name: '',
        address: '',
        loading_time_minutes: ''
      }
      this.valid = false
    },
    agregarNewEventoToCalendar({ date, time }, index, id) {
      console.log('Calendario con indice = ', index)
      console.log('Fecah seleccionada:', date)  
      console.log('Hora seleccionada:', time)
      let timeAux = time.slice(3, 5)
      let timeAuxConverted = parseInt(timeAux)
      if (timeAuxConverted > 0 &&  timeAuxConverted < 30) {
        timeAux = time.slice(0, 2) + ':00'
      } else if (timeAuxConverted >= 30 && timeAuxConverted < 60) {
        timeAux = time.slice(0, 2) + ':30'
      } else {
        timeAux = timeAuxConverted.toString().padStart(2, '0')
      }
      console.log('Hora truncada:', timeAux)
      const nuevoEvento = {
        title: 'Seleccionado',
        date: date,
        time: timeAux, // Evento de 30 min
        duration: this.form.loading_time_minutes,
        color: 'green',
        id: id,
        new: true
      }
      let count = 0
      let indexCalendarSlot = -1
      
      for (let i = 0; i < this.calendars.length; i++) {
        if (this.calendars[i].events.length > 0) {
          for (let j = 0; j < this.calendars[i].events.length; j++) {
            if (this.calendars[i].events[j].new) {
              indexCalendarSlot = i
              count++
            }
          }
        }
        // console.log('Calendario ', i + ' tam = ', this.calendars[i].events.length)
      }

      console.log('CONTADOR = ', count)
      if (count === 0) {
        this.calendars[index].events.push(nuevoEvento)
        this.form.hora = nuevoEvento.time
        const areaSeleccionada = this.parkingSpaces.find(c => c.id === nuevoEvento.id)
        this.form.areas = areaSeleccionada.id
        console.log('Evento agregado:', this.calendars[index].events)
      } else {
        if (this.calendars[indexCalendarSlot].events.length > 0 && this.bandDeleteEvent) {
          this.form.hora = ''
          this.calendars[indexCalendarSlot].events.splice(this.calendars[indexCalendarSlot].events.length - 1, 1)
        }
      }
    },
    open (event) {
      if (event.color === 'green') {
        this.form.hora = event.time
        this.dialogVentana = false
        this.bandDeleteEvent = false
        console.log('EVENTO = ', event)
      }
    },
    onClickInterval(interval) {
      console.log('Intervalo seleccionado:', interval)
    },
    // eliminarEvento(date, index) {
    //   console.log('Fecha del evento a eliminar:', date, index)
    //   // Elimina el evento del arreglo
    //   // Si tienes también el arreglo original eventos2, actualízalo
    //   if (index >= 0){
    //     this.eventos2.splice(index, 1)
    //     this.events2Map[date].splice(index, 1)
    //   }  
    // },
    intervalFormat (interval) {
      // devuelve “00:00, 01:00, … 23:00”
      return interval.time         // usa la versión 24h que ya calcula el calendario
    },
    addMinutesLocal(fechaStr, minutosASumar) {
      const fecha = new Date(fechaStr.toString())
      let fechaNueva = fecha.setMinutes(fecha.getMinutes() + minutosASumar)
      let fechaFinal = new Date(fechaNueva).toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }) + ' ' + new Date(fechaNueva).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })
      return fechaFinal
    },
    convertirFecha(fechaStr) {
      // Crear un objeto Date a partir de la cadena en formato "dd/MM/YYYY hh:mm p.m"
      const regex = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}) (a\.m\.|p\.m\.)/;
      const matches = fechaStr.match(regex);
      
      if (!matches) {
        throw new Error("El formato de la fecha no es válido.");
      }

      const [_, dia, mes, año, horas, minutos, merid] = matches;

      // Crear un objeto Date con la fecha y hora
      let date = new Date(`${año}-${mes}-${dia}T${horas}:${minutos}:00`);

      // Ajustar la hora según el valor "p.m." o "a.m."
      if (merid === 'p.m.' && date.getHours() < 12) {
        date.setHours(date.getHours() + 12); // Convertir a 24 horas si es "p.m."
      }
      if (merid === 'a.m.' && date.getHours() === 12) {
        date.setHours(0); // Convertir las 12 a.m. a 00:00
      }

      // Formatear la fecha de salida en "YYYY-MM-DD hh:mm"
      const añoFormateado = date.getFullYear();
      const mesFormateado = String(date.getMonth() + 1).padStart(2, '0');
      const diaFormateado = String(date.getDate()).padStart(2, '0');
      const horasFormateado = String(date.getHours()).padStart(2, '0');
      const minutosFormateado = String(date.getMinutes()).padStart(2, '0');

      return `${añoFormateado}-${mesFormateado}-${diaFormateado} ${horasFormateado}:${minutosFormateado}`;
    },
    randomColor () {
      const colors = ['blue', 'red', 'green', 'purple', 'indigo', 'orange']
      return colors[Math.floor(Math.random() * colors.length)]
    },
    sumarMinutos(time, minutos) {
      const fecha = new Date(time)
      fecha.setMinutes(fecha.getMinutes() + minutos)
      console.log('Nueva Fecha:', fecha)
      return fecha.toISOString().slice(0, 10)
    },
    enviarInvitacion () {
      this.errores = {}
      if (!this.validateScheduleMode()) {
        return
      }

      this.loadingInvitacion = true
      const startTimeValue = this.form.scheduleMode === 'by_hours' && this.form.start_time
        ? this.form.start_time
        : null
      const endTimeValue = this.form.scheduleMode === 'by_hours' && this.form.end_time
        ? this.form.end_time
        : null

      let dataToSend = {}
      if (this.documentos.length > 0) {
          dataToSend = {
            empresa_id: this.id_empresa,
            referred_email: this.admin === undefined ? '' : this.admin.email,
            invitation_type: 1,
            invitation_date: this.form.fecha,
            expiration: this.form.fechaExpiracion,
            start_time: startTimeValue,
            end_time: endTimeValue,
            transport_type: this.form.typeTransport,
            subject: this.form.subject,
            notes: this.form.notes,
            parking_space_ids: this.form.areas,
            documentation: this.documentos
          }
      } else {
          dataToSend = {
            empresa_id: this.id_empresa,
            referred_email: this.admin === undefined ? '' : this.admin.email,
            invitation_type: 1,
            invitation_date: this.form.fecha,
            expiration: this.form.fechaExpiracion,
            start_time: startTimeValue,
            end_time: endTimeValue,
            transport_type: this.form.typeTransport,
            parking_space_ids: this.form.areas,
            subject: this.form.subject,
            notes: this.form.notes,
          }
      }
      const config = {
        method: 'post',
        url: 'https://empresa-service.intrare.app/Parking/invitations/referred/create/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: dataToSend
      };
      axios(config)
        .then(ok => {
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_invitacion_alta'))
            setTimeout(this.clear, 3000);
            this.loadingInvitacion = false
        })
        .catch(error => {
            if (error.response.status == 400
                && typeof error.response.data == "object"
                && error.response.data) { 
                  this.errores = error.response.data
            }
            if (error.response.status === 401) {
                // this.dialogNopay = true
                console.log('No ha pagado el Servico')
            }
            this.loadingInvitacion = false
        })
      console.log('Invitación enviada:', this.form)
    },
    clear: function () {
      this.errores = {}
      this.$store.commit('snackbar_activate_false')
      this.clean_fields()
    },
    clean_fields(){
      this.form = {
        opciones: [],
        fecha: this.currentDate,
        fechaExpiracion: this.currentDate,
        scheduleMode: 'all_day',
        start_time: '',
        end_time: '',
        fechaVentana: '',
        fechaVentanaRecurrente: '',
        hora: '',
        dias: [],
        documentos: [],
        personas: [],
        areas: null,
        client: '',
        address: '',
        loading_time_minutes: '',
        typeTransport: '',
        notes: '',
        subject: '',
        empresa: '',
        administrador: ''
      }
      this.documentos = []
      // Campos Invitacion Empresarial
      this.administradores = []
      this.id_empresa_empresarial = ''
      this.admin = {}
      this.bandSinAdministrador = false
    },
    rellenaCamposDireccionDuracionCarga (){
      const clienteSeleccionado = this.clients.find(c => c.id === this.form.client)
      if (clienteSeleccionado) {
        this.form.address = clienteSeleccionado.address
        this.form.loading_time_minutes = clienteSeleccionado.loading_time_minutes
        this.llenaCalendario(clienteSeleccionado)
      } else {
        this.form.address = ''
        this.form.loading_time_minutes = ''
      }
    },
    llenaCalendario (client) {
      console.log('Cliente seleccionado para el calendario:', client)
      this.timeInterval = parseInt(client.loading_time_minutes, 10)
      this.numberSlots = 48
    },
    enableCalendar () {
      this.disabledCalendar = this.disabledCalendar2 = this.disabledCalendar3 = this.disabledCalendar4 = this.disabledCalendar5 = this.disabledCalendar6 = true
      const areaSeleccionada = this.parkingSpaces.find(c => c.id === this.form.areas)
      console.log('Área seleccionada:', areaSeleccionada)
      if (areaSeleccionada) {
        if (areaSeleccionada.name === 'Andén No. 1') {
          this.disabledCalendar = false
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Anden No. 1')
        }
        if (areaSeleccionada.name === 'Andén No. 2') {
          this.disabledCalendar = true
          this.disabledCalendar2 = false
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Anden No. 2')
        }
        if (areaSeleccionada.name === 'Andén No. 3') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = false
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Anden No. 3')
        }
        if (areaSeleccionada.name === 'Rampa n°1') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = false
          this.disabledCalendar5 = true
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Rampa n°1')
        }
        if (areaSeleccionada.name === 'Área de carga de atados n°1 (Puerta 4)') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = false
          this.disabledCalendar6 = true
          console.log('Calendario habilitado para Área de carga de atados n°1 (Puerta 4)')
        }
        if (areaSeleccionada.name === 'Área de carga de atados n°2 (Caseta 2-Nave 5)') {
          this.disabledCalendar = true
          this.disabledCalendar2 = true
          this.disabledCalendar3 = true
          this.disabledCalendar4 = true
          this.disabledCalendar5 = true
          this.disabledCalendar6 = false
          console.log('Calendario habilitado para Área de carga de atados n°2 (Caseta 2-Nave 5)')
        }
      }
    },
    generarPDF () {
      const doc = new JSPDF()
      doc.setFontSize(16)
      doc.text('Invitación', 20, 20)
      doc.setFontSize(12)

      doc.text(`📅 Fecha: ${this.form.fecha || 'No definida'}`, 20, 40)
      doc.text(`⏰ Hora: ${this.form.hora || 'No definida'}`, 20, 50)
      doc.text(`🗓️ Días: ${this.form.dias.join(', ') || 'No definidos'}`, 20, 60)
      doc.text(`👥 Invitados: ${this.form.personas.join(', ') || 'Ninguno'}`, 20, 70)
      doc.text('📝 Notas:', 20, 80)

      const lineasNotas = doc.splitTextToSize(this.form.notas || 'Sin notas', 170)
      doc.text(lineasNotas, 20, 90)

      doc.save('invitacion.pdf')
    }
  }
}
</script>
<style scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    opacity: 0.8;
    background-color: #1867c0;
    color: #ffffff;
    border: 1px solid #1867c0;
    font-size: 14px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

    &.with-time {
      position: absolute;
      right: 4px;
      margin-right: 0px;
    }
  }
  .my-event2 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    opacity: 0.8;
    background-color: #5bb445;
    color: #ffffff;
    border: 1px solid #5bb445;
    font-size: 14px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

    &.with-time2 {
      position: absolute;
      right: 4px;
      margin-right: 0px;
    }
  }
  .my-event3 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    opacity: 0.8;
    background-color: #b44545;
    color: #ffffff;
    border: 1px solid #b44545;
    font-size: 14px;
    padding: 3px;
    cursor: pointer;
    margin-bottom: 1px;
    left: 4px;
    margin-right: 8px;
    position: relative;

    &.with-time3 {
      position: absolute;
      right: 4px;
      margin-right: 0px;
    }
  }
/* Esto oculta el encabezado de los días de la semana */
.theme--light.v-calendar-weekly .v-calendar-weekly__head,
.theme--light.v-calendar-monthly .v-calendar-monthly__head {
  display: none;
}
.custom-day-header {
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  padding: 8px;
}
.disabled-calendar {
  pointer-events: none;
  opacity: 0.6; /* opcional, para dar efecto visual de deshabilitado */
}
</style>